import script from "./AkSidebar.vue.js?vue&type=script&lang=js!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./AkSidebar.vue?vue&type=script&lang=js"
export * from "./AkSidebar.vue.js?vue&type=script&lang=js!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./AkSidebar.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__